/**
 * Icon 設定
 * 可增加自訂Icon內容
 * 設置svg內部屬性於content
 * 將svg參數評估後設為可選項目用於Icon.vue插入
 * 大致分類成：
 *  Outlined - 外部線條
 *  Filled - 填滿
 *  Rounded - 圓角
 *  Sharp - 鋒利的
 */

export interface IconContent {
  name: string;
  content: string;
  viewBox?: string;
}

export const CompleteChecked: IconContent = {
  content: `<circle cx="13" cy="13" r="13" fill="currentColor"/><path d="M8.345,63.318a1.112,1.112,0,0,1-1.573,0L.489,57.034a1.668,1.668,0,0,1,0-2.36l.787-.787a1.669,1.669,0,0,1,2.36,0L7.558,57.81l10.6-10.6a1.668,1.668,0,0,1,2.36,0L21.3,48a1.668,1.668,0,0,1,0,2.36Z" transform="translate(5.359 -41.779)" opacity="0.279"/><path d="M8.345,63.318a1.112,1.112,0,0,1-1.573,0L.489,57.034a1.668,1.668,0,0,1,0-2.36l.787-.787a1.669,1.669,0,0,1,2.36,0L7.558,57.81l10.6-10.6a1.668,1.668,0,0,1,2.36,0L21.3,48a1.668,1.668,0,0,1,0,2.36Z" transform="translate(5.359 -42.779)" fill="#ffffff"/>`,
  name: "complete-checked",
  viewBox: "0 0 27.152 26",
};

export const BoyFace: IconContent = {
  content: `<path d="M9,14a1,1,0,1,0-1-1A1,1,0,0,0,9,14Z" transform="translate(-2.667 -3.111)" fill="currentColor"/><path d="M16,13a1,1,0,1,1-1-1A1,1,0,0,1,16,13Z" transform="translate(-3.333 -3.111)" fill="currentColor"/><path d="M11,20a9,9,0,1,0-9-9A9,9,0,0,0,11,20Zm0-1.8a7.206,7.206,0,0,0,6.87-9.36,9.011,9.011,0,0,1-2.357.312A9,9,0,0,1,7.69,4.6,7.2,7.2,0,0,0,11,18.2Z" transform="translate(-2 -2)" fill="currentColor" fill-rule="evenodd"/>`,
  name: "boyface",
  viewBox: "0 0 18 18",
};

export const ChevronLeft: IconContent = {
  content: `<path d="M16.243,6.343,14.828,4.929,7.757,12l7.071,7.071,1.414-1.414L10.586,12Z" transform="translate(-7.757 -4.929)"/>`,
  name: "chevron-left",
  viewBox: "0 0 8.485 14.142",
};

export const ChevronBottom: IconContent = {
  content: `<path d="M8.485,1.414,7.071,0,0,7.071l7.071,7.071,1.414-1.414L2.828,7.071Z" transform="translate(0 8.485) rotate(-90)"/>`,
  name: "chevron-bottom",
  viewBox: "0 0 14.142 8.485",
};

export const ChevronRight: IconContent = {
  content: `<path d="M10.586,6.343,12,4.929,19.071,12,12,19.071l-1.414-1.414L16.243,12Z" transform="translate(-10.586 -4.929)"/>`,
  name: "chevron-right",
  viewBox: "0 0 8.485 14.142",
};

export const PhoneRounded: IconContent = {
  content: `<path d="M-3,9A9,9,0,1,0-.363,2.635,9,9,0,0,0-3,9Zm4.371,3L3.06,10.306h0a.381.381,0,0,1,.539,0l.957.972a.813.813,0,0,0,1.038.09,11.507,11.507,0,0,0,1.56-1.311A11.578,11.578,0,0,0,8.34,8.674a.807.807,0,0,0-.084-1.05l-.99-.99h0a.381.381,0,0,1,0-.539L8.952,4.408h0a.381.381,0,0,1,.539,0l.534.534a2.4,2.4,0,0,1,.6,2.451A8.4,8.4,0,0,1,9.6,9.469a10.783,10.783,0,0,1-1.365,1.656A10.7,10.7,0,0,1,6.408,12.6a7.975,7.975,0,0,1-2.316,1.038,2.4,2.4,0,0,1-2.265-.648l-.456-.453v0h0A.381.381,0,0,1,1.371,12Z" transform="translate(3 0)" fill="currentColor"/>`,
  name: "phone-rounded",
  viewBox: "0 0 18 18",
};

export const HomeOutline: IconContent = {
  content: `<path d="M59.118,207.021H42.278A2.281,2.281,0,0,1,40,204.742V192.755a.792.792,0,0,1,1.585,0v11.987a.694.694,0,0,0,.693.693h16.84a.694.694,0,0,0,.693-.693V192.755a.792.792,0,0,1,1.585,0v11.987A2.281,2.281,0,0,1,59.118,207.021Z" transform="translate(-38.019 -183.249)" fill="currentColor"/><path d="M24.566,28.3a.79.79,0,0,1-.56-.232L14.15,18.209a2.082,2.082,0,0,0-2.942,0L1.353,28.065A.792.792,0,0,1,.232,26.944l9.856-9.856a3.669,3.669,0,0,1,5.183,0l9.856,9.856a.792.792,0,0,1-.56,1.353Z" transform="translate(0 -16.017)" fill="currentColor"/><path d="M183.132,298.285h-6.34a.792.792,0,0,1-.792-.792v-7.033a2.479,2.479,0,0,1,2.476-2.476h2.972a2.479,2.479,0,0,1,2.476,2.476v7.033A.792.792,0,0,1,183.132,298.285Zm-5.547-1.585h4.755v-6.241a.893.893,0,0,0-.892-.891h-2.972a.893.893,0,0,0-.891.891Z" transform="translate(-167.283 -274.513)"/>`,
  name: "home-outline",
  viewBox: "0 0 25.359 23.772",
};

export const Close: IconContent = {
  content: `<path d="M6.245,4.815A1.012,1.012,0,0,0,4.815,6.245l5.843,5.843L4.815,17.931a1.012,1.012,0,0,0,1.431,1.431l5.843-5.843,5.843,5.843a1.012,1.012,0,0,0,1.431-1.431l-5.843-5.843,5.843-5.843a1.012,1.012,0,0,0-1.431-1.431l-5.843,5.843Z" transform="translate(-4.518 -4.518)"/>`,
  name: "close",
  viewBox: "0 0 15.14 15.14",
};

export const Circle: IconContent = {
  content: `<g fill="none" stroke="currentColor" stroke-width="2"><circle cx="7" cy="7" r="7" stroke="none"/><circle cx="7" cy="7" r="6" fill="none"/></g>`,
  name: "circle",
  viewBox: "0 0 14 14",
};

export const Time: IconContent = {
  content: `<path d="M9,7h1.5v4.135h3.739v1.654H9Z" transform="translate(-1.161 -2.86)" fill="currentColor"/><path d="M20,11a9,9,0,1,1-9-9A9,9,0,0,1,20,11Zm-1.8,0A7.2,7.2,0,1,1,11,3.8,7.2,7.2,0,0,1,18.2,11Z" transform="translate(-2 -2)" fill="currentColor" fill-rule="evenodd"/>`,
  name: "time",
  viewBox: "0 0 18 18",
};

export const LocationFilled: IconContent = {
  content: `<path d="M6.867-1c3.8,0,6.72,3,6.72,7.462s-6.564,9.046-6.564,9.046S.053,11.476.053,6.462,3.067-1,6.867-1Z" transform="translate(-0.053 1)" fill="currentColor"/>`,
  name: "time",
  viewBox: "0 0 13.534 16.508",
};

export const Star: IconContent = {
  content: `<path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z" fill="currentColor"/>`,
  name: "star",
  viewBox: "0 0 24 24",
};

export const StarOutline: IconContent = {
  content: `<path d="M15.668 8.626l8.332 1.159-6.065 5.874 1.48 8.341-7.416-3.997-7.416 3.997 1.481-8.341-6.064-5.874 8.331-1.159 3.668-7.626 3.669 7.626zm-6.67.925l-6.818.948 4.963 4.807-1.212 6.825 6.068-3.271 6.069 3.271-1.212-6.826 4.964-4.806-6.819-.948-3.002-6.241-3.001 6.241z" fill="currentColor"/>`,
  name: "star-outline",
  viewBox: "0 0 24 24",
};

export const CircleCheckBoxEmpty: IconContent = {
  content: `<g fill="#eaeced" stroke="#adadad" stroke-width="4"><circle cx="20" cy="20" r="20" stroke="none"/><circle cx="20" cy="20" r="18" fill="none"/></g><path d="M8.388,63.4a1.118,1.118,0,0,1-1.581,0L.492,57.087a1.677,1.677,0,0,1,0-2.372l.791-.791a1.677,1.677,0,0,1,2.372,0L7.6,57.867,18.25,47.214a1.677,1.677,0,0,1,2.372,0l.791.791a1.677,1.677,0,0,1,0,2.372Z" transform="translate(9.048 -35.227)" fill="none"/>`,
  name: "star-outline",
  viewBox: "0 0 40 40",
};

export const CircleCheckBoxChecked: IconContent = {
  content: `<circle cx="20" cy="20" r="20" fill="#10a1d6"/><path d="M8.388,63.4a1.118,1.118,0,0,1-1.581,0L.492,57.087a1.677,1.677,0,0,1,0-2.372l.791-.791a1.677,1.677,0,0,1,2.372,0L7.6,57.867,18.25,47.214a1.677,1.677,0,0,1,2.372,0l.791.791a1.677,1.677,0,0,1,0,2.372Z" transform="translate(9.048 -35.227)" fill="#fff"/>`,
  name: "star-outline",
  viewBox: "0 0 40 40",
};

export const Search: IconContent = {
  content: `<path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14z"/>`,
  name: "search",
  viewBox: "0 0 24 24",
};

export const Add: IconContent = {
  content: `<path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>`,
  name: "add",
  viewBox: "0 0 24 24",
};

export const Remove: IconContent = {
  content: `<path fill="currentColor" d="M19 13H5v-2h14v2z"/>`,
  name: "remove",
  viewBox: "0 0 24 24",
};
